module.exports = __webpack_public_path__ + "static/media/hotel-coming-soon.5810fe76.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/hotel-coming-soon.mp4
// module id = 852
// module chunks = 0